import { combineReducers } from "redux";

import surgeryReferLeadsReducer from "./surgeryReferLeads.reducer";
import surgeryReferLeadsUpdateReducer from "./surgeryReferLeadUpdate.reducer";

export default combineReducers({
    leadList: surgeryReferLeadsReducer,
    UpdateStatus: surgeryReferLeadsUpdateReducer,
});